import { StyleSheet, TouchableOpacity, View } from "react-native";
import CustomSpacing from "../../common/layout/CustomSpacing/CustomSpacing";
import CustomText from "../../common/general/CustomText/CustomText";
import { Cloud } from "../../svgs/CustomCoursework";
import useFileUpload, { UseFileUploadHookProps } from "../../../hooks/useFileUpload";

const FileUploadComponent: React.FC<UseFileUploadHookProps> = ({
  storagePath,
  fileTypes,
  beforeUpload,
  afterUpload,
  onError,
}) => {
  const { handleFileUpload } = useFileUpload({ storagePath, fileTypes, beforeUpload, afterUpload, onError });

  return (
    <TouchableOpacity onPress={handleFileUpload}>
      <View style={styles.fileUpload}>
        <Cloud />
        <CustomSpacing type="vertical" size="s" />
        <CustomText text="Drag & drop or browse" size="m" style={{ color: "#344054" }} />
        <CustomText text="Max file size: 5MB" size="xs" style={{ color: "#3E68FE" }} />
      </View>
    </TouchableOpacity>
  );
};

export default FileUploadComponent;

const styles = StyleSheet.create({
  fileUpload: {
    borderWidth: 1,
    borderColor: "#3E68FE",
    borderRadius: 8,
    borderStyle: "dashed",
    padding: 16,
    alignItems: "center",
    backgroundColor: "#F2F5FF",
  },
});
